const API_REGION_TOKEN = 'xref-api-region';

// The JWT auth token
const AUTH_TOKEN = 'xrefauthtoken';
const REFRESH_TOKEN = 'xrefrefreshtoken';
const XREF_ID = 'xrefid';

const ORG_UID = 'xreforgid';

// JWT delegate auth token
const DELEGATE_AUTH_TOKEN = 'xrefdelegatetoken';

// Signup audit-log action Constants
// Marks a new-org signup flow that paused for Enterprise (XSP) MFA. When set,
// a successful MFA challenge returns the user to org creation instead of
// completing login and redirecting to the app.
const SIGNUP_MFA_IN_PROGRESS = 'signup.mfa.in.progress';
const SIGNUP_CLICKED_CREATE_ORG = 'signup.clicked.create.organisation';
const SIGNUP_CLICKED_ACCEPT_INVITATION = 'signup.clicked.accept.invitation';
const SIGNUP_CLICKED_REQUEST_INVITATION = 'signup.clicked.request.invitation';
const SIGNUP_CLICKED_CONTACT_SUPPORT = 'signup.clicked.contact_support';

// Xref Contact Us page URL
const SIGNUP_CONTACT_XREF_URL = 'https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=sign-up-app';
const SIGNUP_CONTACT_EMPLOYER_URL = 'https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=employer-app';
const SIGNUP_TERMS_XREF_URL = 'https://www.xref.com/enterprise-terms-conditions?src=xref-platform&ltyp=omni&cn=sign-up-app';

// Trust access token to exchange for JWT
const TRUST_ACCESS = 'trustaccess';

// GET_T_AND_C error message
const GET_T_AND_C = 'Get terms and conditions';

// PRIVACY AND T&C URLS
const PRIVACY_URL = 'https://www.xref.com/privacy-policy?src=xref-platform&ltyp=omni&cn=sign-up-app';
const T_AND_C_OMNI = 'https://www.xref.com/21-terms-conditions?src=xref-platform&ltyp=omni&cn=login-app';
const T_AND_C_CLASSIC = 'https://www.xref.com/terms-conditions?src=xref-platform&ltyp=platform&cn=login-app';

const AUTH_DOMAIN_WHITELIST = [
    new RegExp(/^[a-zA-Z0-9-\.]*\.?xref\.com$/),
    'localhost:8000',
    '127.0.0.1:8000',
    'localhost:8001',
    '127.0.0.1:8001',
    'localhost:8003',
    '127.0.0.1:8003',
];

// Tracking ID
const TRACKING_ID = 'xreftrackingid';

// Used for I18N, sets the default(/fallback) language
const LOCALE = 'en-au';

// The key used for localStorage, must be consistent in all apps with i18n enabled
const LOCALE_TOKEN = 'xref-chosen-locale';


// Xref contrast setting
const CONTRAST = 'xrefcontrast';

// Used for I18N, dictates which languages are available to the app
const SUPPORTED_LOCALES = [
    {label: 'English (AU)', key: 'en-au'},
    {label: 'English (US)', key: 'en-us'},
    {label: 'Français (CA)', key: 'fr-ca'},
    {label: 'Español (US)', key: 'es-us'},
];

const OMNI_LOCALES = ['en-au', 'en-us', 'fr-ca', 'es-us'];

const DEFAULT_REDIRECT_URL = 'https://employer.xref.com';

// UUID storage key for SSO validation
const SSO_UUID = 'xref-sso-uuid';

// UUID storage key for SSO validation
const SSO_NONCE = 'xref-sso-nonce';

// UUID storage key for SSO validation
const SSO_REDIRECT_URL = 'xref-sso-redirect-url';

// Routes for SSO types
const SSO_URLS = {
    OPEN_ID: 'sso/open-id',
    SAML: 'sso/saml'
};

// Selected region for SAML
const SELECTED_REGION_SAML = 'xref-selected-region-saml';

const RETURN_URL = 'xref-return-url';

const LOGIN_EMAIL = 'xref-last-origin-email';

const PLATFORM = 'xref-platform';

const ORG_INDUSTRIES = [
    {key: 1, value: 'signUpText.orgCreation.industries.advertising'},
    {key: 2, value: 'signUpText.orgCreation.industries.agriculture'},
    {key: 3, value: 'signUpText.orgCreation.industries.architecture'},
    {key: 4, value: 'signUpText.orgCreation.industries.callCenter'},
    {key: 5, value: 'signUpText.orgCreation.industries.construction'},
    {key: 6, value: 'signUpText.orgCreation.industries.defence'},
    {key: 7, value: 'signUpText.orgCreation.industries.education'},
    {key: 8, value: 'signUpText.orgCreation.industries.energy'},
    {key: 9, value: 'signUpText.orgCreation.industries.engineering'},
    {key: 10, value: 'signUpText.orgCreation.industries.facilitiesManagement'},
    {key: 11, value: 'signUpText.orgCreation.industries.finance'},
    {key: 12, value: 'signUpText.orgCreation.industries.foodHospitality'},
    {key: 13, value: 'signUpText.orgCreation.industries.governmentFederal'},
    {key: 14, value: 'signUpText.orgCreation.industries.governmentLocal'},
    {key: 15, value: 'signUpText.orgCreation.industries.governmentState'},
    {key: 16, value: 'signUpText.orgCreation.industries.healthcare'},
    {key: 17, value: 'signUpText.orgCreation.industries.hr'},
    {key: 18, value: 'signUpText.orgCreation.industries.it'},
    {key: 19, value: 'signUpText.orgCreation.industries.insurance'},
    {key: 20, value: 'signUpText.orgCreation.industries.legal'},
    {key: 21, value: 'signUpText.orgCreation.industries.manufacturing'},
    {key: 22, value: 'signUpText.orgCreation.industries.nfpCharity'},
    {key: 23, value: 'signUpText.orgCreation.industries.nfpNonCharity'},
    {key: 24, value: 'signUpText.orgCreation.industries.office'},
    {key: 25, value: 'signUpText.orgCreation.industries.oilGas'},
    {key: 26, value: 'signUpText.orgCreation.industries.procurement'},
    {key: 27, value: 'signUpText.orgCreation.industries.professionalServices'},
    {key: 28, value: 'signUpText.orgCreation.industries.property'},
    {key: 29, value: 'signUpText.orgCreation.industries.resources'},
    {key: 30, value: 'signUpText.orgCreation.industries.retail'},
    {key: 31, value: 'signUpText.orgCreation.industries.salesMarketing'},
    {key: 32, value: 'signUpText.orgCreation.industries.science'},
    {key: 33, value: 'signUpText.orgCreation.industries.telecommunications'},
    {key: 34, value: 'signUpText.orgCreation.industries.transport'},
    {key: 35, value: 'signUpText.orgCreation.industries.travel'},
    {key: 36, value: 'signUpText.orgCreation.industries.utilities'},
    {key: 37, value: 'signUpText.orgCreation.industries.wealth'},
    {key: 38, value: 'signUpText.orgCreation.industries.other'}
];

const DATA_REGIONS = [
    {key: 'us', value: 'signUpText.orgCreation.dataRegions.unitedStates'},
    {key: 'au', value: 'signUpText.orgCreation.dataRegions.australia'},
    {key: 'ca', value: 'signUpText.orgCreation.dataRegions.canada'},
    {key: 'eu', value: 'signUpText.orgCreation.dataRegions.europe'}
];

const EN_ORG_INDUSTRIES = {
    1: "Advertising, Media & Entertainment",
    2: "Agriculture",
    3: "Architecture",
    4: "Call Centre & Customer Services",
    5: "Construction & Civil Engineering",
    6: "Defence, Military & Armed Forces",
    7: "Education",
    8: "Energy",
    9: "Engineering",
    10: "Facilities Management",
    11: "Finance, Accounting & Banking",
    12: "Food & Hospitality",
    13: "Government - Federal/Central",
    14: "Government - Local",
    15: "Government - State",
    16: "Healthcare & Medical",
    17: "HR & Recruitment",
    18: "Information Technology",
    19: "Insurance",
    20: "Legal",
    21: "Manufacturing",
    22: "NFP - Charity",
    23: "NFP - Non-Charity",
    24: "Office & Administration",
    25: "Oil & Gas",
    26: "Procurement",
    27: "Professional Services",
    28: "Property & Real Estate",
    29: "Resources & Mining",
    30: "Retail & Consumer Products",
    31: "Sales & Marketing",
    32: "Science, Biotech & Pharmaceuticals",
    33: "Telecommunications",
    34: "Transport & Logistics",
    35: "Travel & Tourism",
    36: "Utilities",
    37: "Wealth & Investment",
    38: "Other",
};


const ASSETS_URLS = {
    EYE_CLOSED_ICON: 'https://assets.xref.com/omni/shared/eye_closed_icon.svg',
    EYE_OPEN_ICON: 'https://assets.xref.com/omni/shared/eye_open_icon.svg',
    ICON_DANGER: 'https://assets.xref.com/omni/shared/icon-danger.svg',
};

const ORG_SIZES = [
    {key: '1 - 75', value: '1 - 75', mapping: '1'},
    {key: '76 - 150', value: '76 - 150', mapping: '2'},
    {key: '151 - 300', value: '151 - 300', mapping: '3'},
    {key: '301 - 500', value: '301+', mapping: '4'},
];

// Exporting a set of constants allows these unchanging values to be parsed around the app as a singleton service
export default {
    AUTH_TOKEN,
    REFRESH_TOKEN,
    XREF_ID,
    ORG_UID,
    DELEGATE_AUTH_TOKEN,
    TRUST_ACCESS,
    TRACKING_ID,
    API_REGION_TOKEN,
    CONTRAST,
    LOCALE,
    LOCALE_TOKEN,
    SUPPORTED_LOCALES,
    DEFAULT_REDIRECT_URL,
    AUTH_DOMAIN_WHITELIST,
    SSO_UUID,
    SSO_NONCE,
    SSO_REDIRECT_URL,
    RETURN_URL,
    SSO_URLS,
    LOGIN_EMAIL,
    OMNI_LOCALES,
    PLATFORM,
    SELECTED_REGION_SAML,
    GET_T_AND_C,
    PRIVACY_URL,
    T_AND_C_OMNI,
    T_AND_C_CLASSIC,
    ORG_INDUSTRIES,
    EN_ORG_INDUSTRIES,
    ASSETS_URLS,
    SIGNUP_MFA_IN_PROGRESS,
    SIGNUP_CLICKED_CREATE_ORG,
    SIGNUP_CLICKED_ACCEPT_INVITATION,
    SIGNUP_CLICKED_REQUEST_INVITATION,
    SIGNUP_CONTACT_XREF_URL,
    SIGNUP_CONTACT_EMPLOYER_URL,
    SIGNUP_CLICKED_CONTACT_SUPPORT,
    SIGNUP_TERMS_XREF_URL,
    DATA_REGIONS,
    ORG_SIZES
};
